import { create } from 'zustand';
import axios from 'axios';

export interface User {
  id: string;
  email: string;
  name: string;
  lastname1: string;
  group_id: string;
  group_name: string;
}

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  login: (user: string, password: string) => Promise<void>;
  logout: () => void;
  validateToken: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,

  login: async (user: string, password: string) => {
    try {
      set({ isLoading: true, error: null });
      const url = `${import.meta.env.VITE_AUTH_API_URL}/api/auth_login`;
      const params = new URLSearchParams();
      params.append('user', user);
      params.append('password', password);
      const response = await axios.post(url, params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      const { success, message, data } = response.data;
      if (!success || !data) {
        set({
          error: message || 'Invalid credentials',
          isLoading: false,
          isAuthenticated: false,
          user: null,
        });
        throw new Error(message || 'Invalid credentials');
      }
      localStorage.setItem('auth_token', data.token);
      localStorage.setItem('auth_user', JSON.stringify(data.user));
      set({ user: data.user, isAuthenticated: true, isLoading: false });
    } catch (error: any) {
      set({
        error: error?.response?.data?.message || 'Invalid credentials',
        isLoading: false,
        isAuthenticated: false,
        user: null,
      });
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    // Also remove language preference on logout
    localStorage.removeItem('user_language');
    set({
      user: null,
      isAuthenticated: false,
      error: null,
    });
  },

  validateToken: async () => {
    const token = localStorage.getItem('auth_token');
    const userStr = localStorage.getItem('auth_user');
    
    if (!token || !userStr) {
      set({ isAuthenticated: false, user: null });
      return;
    }
    
    try {
      const user = JSON.parse(userStr) as User;
      set({ isAuthenticated: true, user });
    } catch (error) {
      // Si hay error al parsear el JSON, limpiamos el localStorage
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      set({ isAuthenticated: false, user: null });
    }
  },
}));